import React from 'react'
import SideBar from './components/sidebar/SideBar'
import Main from './components/main/Main'

const App = () => {
  return (
    <>
    <SideBar/>
    <Main/>
    </>
  )
}

export default App
